import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { ContextBanner } from '../components/ContextBanner';

export function AppShell() {
  return (
    <div className="app-shell">
      <TopNav />
      <ContextBanner />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
